import table from './../organisations/table'

export default {
    table,
}